enum OvertimePayRateType {
  ONE_POINT_FIVE = 1.5,
  TWO_POINT_ZERO = 2.0,
}

export default OvertimePayRateType;
